import { Combobox } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import { ulCss } from "./LevelLockMenu.style";

const propTypes = {
  /**
   * Helpful information to the user that renders underneath the input
   */
  helperText: PropTypes.string,
  /**
   * String labeling the input
   */
  label: PropTypes.string,
  /**
   * Array of items to display inside drop down menu
   */
  levels: PropTypes.arrayOf(PropTypes.string),
  /**
   * Item currently selected by user
   */
  selectedItem: PropTypes.func,
  /**
   * Item to display as default selected item
   */
  defaultValue: PropTypes.string,
  /**
   * A function that is passed the item and can be used to render other elements along with the item inside the li tag.
   * Note: This prop only changes what appears in the dropdown and will not effect what appears in the input field after a selection has been made.
   */
  renderItem: PropTypes.func,
  /**
   * Pass style objects to override default styles from Angelou
   */
  __css: PropTypes.object,
};

const LevelLockMenu = ({
  helperText,
  label,
  levels,
  selectedItem,
  defaultValue,
  renderItem,
  __css,
}) => {
  return (
    <Combobox
      helperText={helperText}
      items={levels}
      label={label}
      onSelectedItemChange={(e) => {
        selectedItem(e);
      }}
      selectedItem={defaultValue}
      __cssFor={{
        root: [ulCss, { ...__css }],
      }}
      __renderItem={renderItem}
    />
  );
};

LevelLockMenu.propTypes = propTypes;
export default withTrackEvent(LevelLockMenu);
